export const FETCH_LEAGUE_ARCHIVE_REQUEST = 'FETCH_LEAGUE_ARCHIVE_REQUEST';
export const FETCH_LEAGUE_ARCHIVE_SUCCESS = 'FETCH_LEAGUE_ARCHIVE_SUCCESS';
export const FETCH_LEAGUE_ARCHIVE_FAIL    = 'FETCH_LEAGUE_ARCHIVE_FAIL';


export const FETCH_ARCHIVED_LEADERBOARD_REQUEST = 'FETCH_ARCHIVED_LEADERBOARD_REQUEST';
export const FETCH_ARCHIVED_LEADERBOARD_SUCCESS = 'FETCH_ARCHIVED_LEADERBOARD_SUCCESS';
export const FETCH_ARCHIVED_LEADERBOARD_FAIL    = 'FETCH_ARCHIVED_LEADERBOARD_FAIL';
